import { Box, Typography } from "@mui/material";
import classes from "../../css/MahnungSwitcher.module.css";

import {
  AdminMahnungFilterTypes,
  ALL_MAHNUNG,
  ACTIVE_MAHNUNG,
  COMPLETED_MAHNUNG,
  IMPORT_MAHNUNG,
  INKASSO_MAHNUNG,
} from "../../constants/admin-management-constants";

const AdminMahnungSwitcher: React.FC<{
  activeTab: AdminMahnungFilterTypes;
  onChangeTab: (newTab: AdminMahnungFilterTypes) => void;
}> = ({ activeTab, onChangeTab }) => {
  const isAllTab = activeTab === ALL_MAHNUNG;
  const isActiveTab = activeTab === ACTIVE_MAHNUNG;
  const isImportTab = activeTab === IMPORT_MAHNUNG;
  const isCompletedTab = activeTab === COMPLETED_MAHNUNG;
  const isInkassoTab = activeTab === INKASSO_MAHNUNG;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        width: "55%",
        margin: "auto",
      }}
    >
      <button
        style={{ cursor: "pointer" }}
        className={`${classes.listBtn} ${
          isAllTab ? classes.btnActive : classes.btnNotActive
        } `}
        onClick={() => onChangeTab(ALL_MAHNUNG)}
      >
        <Typography
          sx={{
            color: isAllTab ? "white" : "var(--grey)",
            fontWeight: "bold",
            fontSize: "var(--h2)",
          }}
        >
          alle
        </Typography>
      </button>
      <button
        style={{ cursor: "pointer" }}
        className={`${classes.middleBtn} ${
          isImportTab ? classes.btnActive : classes.btnNotActive
        } `}
        onClick={() => onChangeTab(IMPORT_MAHNUNG)}
      >
        <Typography
          sx={{
            color: isImportTab ? "white" : "var(--grey)",
            fontWeight: "bold",
            fontSize: "var(--h2)",
          }}
        >
          import
        </Typography>
      </button>

      <button
        style={{ cursor: "pointer" }}
        className={`${classes.middleBtn} ${
          isActiveTab ? classes.btnActive : classes.btnNotActive
        } `}
        onClick={() => onChangeTab(ACTIVE_MAHNUNG)}
      >
        <Typography
          sx={{
            color: isActiveTab ? "white" : "var(--grey)",
            fontWeight: "bold",
            fontSize: "var(--h2)",
          }}
        >
          aktiv
        </Typography>
      </button>

      <button
        style={{ cursor: "pointer" }}
        className={`${classes.middleBtn} ${
          isCompletedTab ? classes.btnActive : classes.btnNotActive
        } `}
        onClick={() => onChangeTab(COMPLETED_MAHNUNG)}
      >
        <Typography
          sx={{
            color: isCompletedTab ? "white" : "var(--grey)",
            fontWeight: "bold",
            fontSize: "var(--h2)",
          }}
        >
          abgeschlossen
        </Typography>
      </button>

      <button
        style={{ cursor: "pointer" }}
        className={`${classes.archiveBtn} ${
          isInkassoTab ? classes.btnActive : classes.btnNotActive
        } `}
        onClick={() => onChangeTab(INKASSO_MAHNUNG)}
      >
        <Typography
          sx={{
            color: isInkassoTab ? "white" : "var(--grey)",
            fontWeight: "bold",
            fontSize: "var(--h2)",
          }}
        >
          inkasso
        </Typography>
      </button>
    </Box>
  );
};

export default AdminMahnungSwitcher;
